import { LocalDate } from '@js-joda/core';
import { TransactionType } from 'src/types/transaction-type.enum';
import { useFilteredTransactions, useReviewableTransactions } from 'src/hooks/queries/transactions';
import { useSearchParams } from 'src/hooks/useSearchParams';
import { PaginatedTransactionsModel } from 'src/types/paginated-transactions.model';
import { Direction } from 'src/types/sort-direction.enum';
import { UseQueryResult } from '@tanstack/react-query';
import { TransactionField } from 'src/bw/project-jaeger/data/TransactionField.enum';

/**
 * Return the review transactions filtered on the URL Search Parameters
 * This should be removed during WMT-13745
 */
export function usePaginatedReviewableTransactions(): UseQueryResult<PaginatedTransactionsModel> {
    const [searchParams] = useSearchParams();
    const search: string = searchParams.get('search');
    const page: number = parseInt(searchParams.get('page')) || 1;
    const isAscending: boolean = searchParams.get('direction') === Direction.ASCENDING;
    const field: TransactionField = (searchParams.get('field') as TransactionField) || undefined;

    return useReviewableTransactions({
        search,
        field,
        isAscending,
        page
    });
}

/** Return the transactions filtered on the URL Search Parameters */
export default function usePaginatedTransactions(): UseQueryResult<PaginatedTransactionsModel> {
    const [searchParams] = useSearchParams();
    const startDate: LocalDate = searchParams.get('start') && LocalDate.parse(searchParams.get('start'));
    const endDate: LocalDate = searchParams.get('end') && LocalDate.parse(searchParams.get('end'));
    const accountId: string = searchParams.get('account');
    const search: string = searchParams.get('search');
    const type: TransactionType = searchParams.get('type') as TransactionType;
    const groupUid: string = searchParams.get('group');
    const incomeSourceUid: string = searchParams.get('incomesource');
    const showHidden: boolean = searchParams.get('showHidden') === 'true';
    const page: number = parseInt(searchParams.get('page')) || 1;
    const isAscending: boolean = searchParams.get('direction') === Direction.ASCENDING;
    const field: TransactionField = (searchParams.get('field') as TransactionField) || undefined;

    return useFilteredTransactions({
        startDate,
        endDate,
        search,
        account: accountId,
        type,
        group: groupUid,
        income: incomeSourceUid,
        field,
        isAscending,
        page,
        showHidden
    });
}
